import React from "react";
import styled from "styled-components";
import DetailTitleBox from "../components/DetailTitleBox";
import DetailImageBox from "../components/DetailImageBox";
import DetailTypeBox from "../components/DetailTypeBox";

import { useLocation } from "react-router-dom";

const GlobalStyleds = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const DetailBox = styled.div`
    width: 1000px;
    height: 800px;
    background-color: #F3F4F6;

    @media all and (max-width:479px) {
        width: 100%;
        height: 60%;
    }
`;

const DetailContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;
    height: 700px;

    @media all and (max-width:479px) {
        gap: 5%;
        width: 100%;
        height: 50%;
    }
`;


function Detail() {
    const location = useLocation();
    const { pokemonData } = location.state || {};

    return (
        <GlobalStyleds>
            <DetailBox>
                <DetailTitleBox pokemonData={pokemonData}/>
                <DetailContainer>
                    <DetailImageBox pokemonData={pokemonData} />
                    <DetailTypeBox pokemonData={pokemonData} />
                </DetailContainer>
            </DetailBox>
        </GlobalStyleds>
    )
};

export default Detail;